module.exports = __webpack_public_path__ + "img/classic-button.bdd300f5.png";